import LocalisedLoadingProvider from "components/LocalisedLoadingProvider";
import NotFound from "features/NotFound";
import { Suspense, lazy } from "react";
import { Route } from "react-router-dom";
import { Routes } from "components/Sentry/Routes";
import CompletedWorkoutsProvider from "./providers/CompletedWorkoutsProvider";
import WorkoutsProvider from "./providers/WorkoutsProvider";
import SearchTextProvider from "providers/SearchTextProvider/SearchTextProvider";
import TableSortProvider from "providers/TableSortProvider/TableSortProvider";
import SelectedEntitiesProvider from "providers/SelectedEntitiesProvider/SelectedEntitiesProvider";
import FilteredWorkoutsProvider from "./providers/FilteredWorkoutsProvider";
import SelectedWorkoutLabelsProvider from "providers/SelectedWorkoutLabelsProvider";
import WorkoutLabelOptionsProvider from "./providers/WorkoutLabelOptionsProvider";
import { useTranslation } from "react-i18next";
import LogEventContext from "components/charting/contexts/LogEventContext";
import logEvent from "utils/logEvent";
import InfoMessageProvider from "providers/InfoMessageProvider";

const CreateWorkout = lazy(() => import("./CreateWorkout"));
const WorkoutAthleteReview = lazy(() => import("./WorkoutAthleteReview"));
const WorkoutOverview = lazy(() => import("./WorkoutOverview"));
const EditWorkout = lazy(() => import("./EditWorkout"));
const ReviewAllWorkouts = lazy(() => import("./AllWorkouts"));

function WorkoutsRoutes() {
  const { t } = useTranslation();
  return (
    <InfoMessageProvider>
      <WorkoutsProvider>
        <CompletedWorkoutsProvider>
          <SearchTextProvider>
            <SelectedEntitiesProvider>
              <WorkoutLabelOptionsProvider>
                <SelectedWorkoutLabelsProvider>
                  <TableSortProvider initialSortKey="updatedAt" initialDirection="desc">
                    <FilteredWorkoutsProvider>
                      <LocalisedLoadingProvider>
                        <Routes>
                          <Route
                            path={"create"}
                            element={
                              <Suspense fallback={<div>{t("global.loading_text")}</div>}>
                                <CreateWorkout />
                              </Suspense>
                            }
                          />
                          <Route
                            path={"/"}
                            element={
                              <Suspense fallback={<div>{t("global.loading_text")}</div>}>
                                <ReviewAllWorkouts />
                              </Suspense>
                            }
                          />
                          <Route
                            path={":workoutId"}
                            element={
                              <Suspense fallback={<div>{t("global.loading_text")}</div>}>
                                <WorkoutOverview />
                              </Suspense>
                            }
                          />
                          <Route
                            path={":workoutId/completed/:completedWorkoutId"}
                            element={
                              <Suspense fallback={<div>{t("global.loading_text")}</div>}>
                                <LogEventContext.Provider
                                  value={(properties) => logEvent("ATHLETE_COMPLETED_WORKOUT", properties)}
                                >
                                  <WorkoutAthleteReview />
                                </LogEventContext.Provider>
                              </Suspense>
                            }
                          />
                          <Route
                            path={":workoutId/edit"}
                            element={
                              <Suspense fallback={<div>{t("global.loading_text")}</div>}>
                                <EditWorkout />
                              </Suspense>
                            }
                          />
                          <Route
                            path="*"
                            element={<NotFound buttonText={t("workouts.return_to_workouts")} link="/workouts" />}
                          />
                        </Routes>
                      </LocalisedLoadingProvider>
                    </FilteredWorkoutsProvider>
                  </TableSortProvider>
                </SelectedWorkoutLabelsProvider>
              </WorkoutLabelOptionsProvider>
            </SelectedEntitiesProvider>
          </SearchTextProvider>
        </CompletedWorkoutsProvider>
      </WorkoutsProvider>
    </InfoMessageProvider>
  );
}
export default WorkoutsRoutes;
